import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'off-white' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    'off-white': 'bg-[#FDFCF8]',
    dark: 'bg-stone-900 text-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-6 ${bgColors[background]} ${className}`} data-id="element-324">
      <div className="max-w-3xl mx-auto w-full" data-id="element-325">{children}</div>
    </section>;
}